<script>
import { resetAdminUserPwd } from '@/api/data'
import md5 from 'md5'

export default {
  name: 'ResetPassword',
  props: ['layerid', 'record'],
  data () {
    return {
      form: this.$form.createForm(this),
      loading: false
    }
  },
  methods: {
    getErrorMessage (msg) {
      if (typeof msg === 'string') {
        return msg
      }
      const lang = this.$i18n.locale || 'en-US'
      const langKey = lang.replace('-', '').toLowerCase()
      const enKey = 'en'
      const zhKey = 'zh'
      const jaKey = 'ja'

      if (langKey.includes('zh')) {
        return msg[zhKey] || msg['zh-CN'] || msg['en'] || msg['en-US'] || ''
      } else if (langKey.includes('ja')) {
        return msg[jaKey] || msg['ja-JP'] || msg['en'] || msg['en-US'] || ''
      } else {
        return msg[enKey] || msg['en-US'] || msg['en'] || ''
      }
    },
    handleSubmit () {
      const { form: { validateFields } } = this

      validateFields((err, values) => {
        if (!err) {
          this.loading = true

          const params = {
            uid: this.record.user_id,
            passwd: md5(values.password)
          }

          resetAdminUserPwd(params)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('user.password.reset.success'))
                this.form.resetFields()
                this.$layer.close(this.layerid)
              } else {
                this.$message.error(this.getErrorMessage(res.msg) || this.$t('user.password.reset.fail'))
              }
            })
            .catch(() => {
              this.$message.error(this.$t('user.password.reset.fail'))
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<template>
  <div style="width: 100%;padding: 8px;">
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
      <a-form-item :label="$t('user.name')">
        <a-input
          disabled
          :value="record.name"
        />
      </a-form-item>

      <a-form-item :label="$t('user.account')">
        <a-input
          disabled
          :value="record.account"
        />
      </a-form-item>

      <a-form-item :label="$t('user.password')">
        <a-input
          type="password"
          autocomplete="new-password"
          v-decorator="[
            'password',
            { rules: [{ required: true, min: 6, message: $t('user.password.min.length') }] }
          ]"
          :placeholder="$t('user.password.min.length')"
        />
      </a-form-item>

      <a-form-item :wrapper-col="{ span: 14, offset: 6 }">
        <a-button
          type="primary"
          html-type="submit"
          :loading="loading"
          @click="handleSubmit"
        >
          {{ $t('user.password.reset') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<style scoped lang='less'>
</style>
